import { useQuery } from '@redwoodjs/web';

export type CustomerPortalInvoice = {
  id: string;
  slug: string;
  status: string;
  counterPartyName: string;
  paymentTerms: string;
  invoiceDate: string;
  dueDate: string;
  totalAmountDue: number;
  totalPaid: number;
  amountRemaining: number;
  orderSlug: string;
  adjustments: Array<{ id: number; amount: number; reason: string; memo: string }>;
  expenses: Array<{ id: number; category: string; quantity: number; description: string; totalAmount: number }>;
};

export const GET_CUSTOMER_PORTAL_INVOICE = gql`
  query GetCustomerPortalInvoice($slug: String!) {
    customerPortalInvoice(slug: $slug) {
      id
      slug
      status
      counterPartyName
      paymentTerms
      invoiceDate
      dueDate
      totalAmountDue
      totalPaid
      amountRemaining
      orderSlug
      adjustments {
        id
        reason
        amount
        memo
      }
      expenses {
        id
        category
        quantity
        description
        totalAmount
        includedInDlvPrice
      }
    }
  }
`;

export default function useCustomerPortalInvoice(slug: string) {
  const { data } = useQuery<{ customerPortalInvoice: CustomerPortalInvoice }>(GET_CUSTOMER_PORTAL_INVOICE, {
    variables: { slug },
  });
  return data?.customerPortalInvoice;
}
